/* eslint-disable no-use-before-define */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable wrap-iife */
G.Helpers = G.Helpers || {};

G.Helpers.mapChestsMgr = (function () {
  let saveStateMgr = null;
  let chestData = null;
  const showBotOptinIconAfter = -1;
  const showBotOptinPopupAfter = -1;

  return {
    init: init,

    getChestMapPosition: getChestMapPosition,
    getChestStarsRequirement: getChestStarsRequirement,
    getAllChestsIds: getAllChestsIds,
    iconAndPopupIn: iconAndPopupIn,
    showBotOptinIconAfter: showBotOptinIconAfter,
    showBotOptinPopupAfter: showBotOptinPopupAfter,
    isChestOpened: isChestOpened,
  }

  function init(data) {
    saveStateMgr = G.saveState;
    chestData = data || chestData;
  }

  function getSaveData() {
    return saveStateMgr.data.mapChests;
  }

  function getChestData(id) {
    return chestData.find(function (chest) { return chest.id === id; });
  }

  function getChestMapPosition(id) {
    const chest = getChestData(id);
    if (!chest) return null;
    return {
      x: chest.mapX,
      y: chest.mapY,
    };
  }

  function getChestStarsRequirement(id) {
    const chest = getChestData(id);
    if (!chest) return null;
    return chest.req;
  }

  /**
   * Not used anymore outside of migration
   * @param {number} id 
   */
  function isChestOpened(id) {
    const saveData = getSaveData();
    return saveData[id];
  }

  function getAllChestsIds() {
    return chestData.map(function (chest) {
      return chest.id;
    });
  }

  function iconAndPopupIn(iconIn, popupIn) {
    this.showBotOptinIconAfter = iconIn;
    this.showBotOptinPopupAfter = popupIn;
  }
})();
